import { getColor } from "../../../theme";
export default (function (_a) {
    var theme = _a.theme, background = _a.background;
    if (!background)
        return "";
    var value = getColor(background)({ theme: theme });
    return value && "background-color: ".concat(value, ";");
});
